<div cdkDrag
     cdkDragHandle
     cdkDragRootElement=".cdk-overlay-pane"
     class="main-content"
>
    <div class="main-content-title">
        <i class="ri-close-fill main-content-close"
           (click)="cancelAction()"
        ></i>

        <h2>{{ header }}</h2>

        @if (content) {
            <p>{{ content }}</p>
        }

        <small>{{ 'MODALS.TEXT.PIN' | translate }}</small><br>
        <h3>{{ 'MODALS.FIELDS.PIN' | translate }}:</h3>
    </div>

    <app-code-input
            (codeCompleted)="pin = $event; setFocus()"
    ></app-code-input>

    <div class="button-container">
        <button #submit
                (click)="pinEmit()"
                mat-flat-button
                [disabled]="!pin"
                class="main-content-button apply"
        >
            <i class="ri-checkbox-fill"></i>
            <span *ngIf="isSign">{{ 'MODALS.BUTTONS.CONFIRM' | translate }}</span>
            <span *ngIf="!isSign">{{ 'MODALS.BUTTONS.RECALL' | translate }}</span>
        </button>
        <button (click)="cancelAction()"
                mat-flat-button
                class="main-content-button cancel"
        >
            <i class="ri-close-fill"></i>
            <span>{{ 'MODALS.BUTTONS.CLOSE' | translate }}</span>
        </button>
    </div>
</div>
